import { render, staticRenderFns } from "./BusinessPayrollDetails.vue?vue&type=template&id=42b0597a&scoped=true&"
import script from "./BusinessPayrollDetails.vue?vue&type=script&lang=ts&"
export * from "./BusinessPayrollDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b0597a",
  null
  
)

export default component.exports